import React, { useState, useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import BlogCard from "../home/featured-blog/blogCard";

const InterestedArticles = ({ posts, showMiniImg = true, enableLink = false }) => {
  const [swiper, setSwiper] = useState(null);
  const swiperRef = useRef(null);

  return (
    <div className="relative w-full mt-4 blog-slides md:mt-8">
      <div className="pb-5 md:pt-2">
        <Swiper
          ref={swiperRef}
          speed={1300}
          onSwiper={setSwiper}
          grabCursor={true}
          spaceBetween={0}
          loop={true}
          className="z-20"
          slidesPerView={1.25}
          onSlideChange={(swiperCore) => {
            const { realIndex } = swiperCore;
          }}
          breakpoints={{
            480: {
              slidesPerView: 1.25,
              spaceBetween: 0
            },
            640: {
              slidesPerView: 3,
              spaceBetween: 0
            },
            1024: {
              slidesPerView: 6,
              spaceBetween: 15
            }
          }}
        >
          {posts.map((blog, idx) => (
            <SwiperSlide key={idx}>
              <BlogCard blog={blog} showMiniImg={showMiniImg} enableLink={enableLink} />
            </SwiperSlide>
          ))}
        </Swiper>

        <div
          className="swiper-button-prev !-left-16 !w-11 h-11 after:hidden !hidden md:!block"
          onClick={() => {
            swiper.slidePrev();
          }}
        />

        <div
          className="swiper-button-next rotate-180 !-right-16 !w-11 h-11 after:hidden !hidden md:!block"
          onClick={() => {
            swiper.slideNext();
          }}
        />
      </div>
    </div>
  );
};

export default InterestedArticles;
